import { createContext, useState, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_METADATA = {
  reply: null
};
export const ComposerMetadataContext = /*#__PURE__*/createContext({
  reply: null,
  setComposerMetadata: () => {}
});
export const ComposerMetadataProvider = ({
  children
}) => {
  const [composerMetadata, setComposerMetadata] = useState(INITIAL_METADATA);
  const contextValue = useMemo(() => Object.assign({}, composerMetadata, {
    setComposerMetadata
  }), [composerMetadata, setComposerMetadata]);
  return /*#__PURE__*/_jsx(ComposerMetadataContext.Provider, {
    value: contextValue,
    children: children
  });
};
ComposerMetadataProvider.displayName = 'ComposerMetadataProvider';